/* @flow */
import * as React from 'react';

import './styles/BoxSelect.scss';

/**
 * [Box](/internal/components/Box) options.
 *
 *
 * # Common usage
 *
 * ```example
 * <BoxSelect title="BoxSelect title">
 *   <BoxSelectItem
 *     label="BoxSelectItem"
 *     action={() => window.alert('Selected!')}
 *   />
 *   <BoxSelectItem
 *     label="BoxSelectItem"
 *     action={() => window.alert('Selected!')}
 *   />
 * </BoxSelect>
 * ```
 *
 * # Required props
 *
 * ```example
 * <BoxSelect>
 *   <BoxSelectItem
 *     label="BoxSelectItem"
 *     action={() => window.alert('Selected!')}
 *   />
 *   <BoxSelectItem
 *     label="BoxSelectItem"
 *     action={() => window.alert('Selected!')}
 *   />
 * </BoxSelect>
 * ```
 *
 *
 * # TODO
 * * Refactor `title` prop with [Heading](/internal/components/Heading)
 */

class BoxSelect extends React.Component<{
  title?: string | React.Element<any>,
  children?: React.Node,
}> {
  render() {
    const { children, title } = this.props;

    return (
      <div className="BoxSelect">
        {title && <h3 className="BoxSelect-title">{title}</h3>}
        <div className="BoxSelect-items">{children}</div>
      </div>
    );
  }
}

export default BoxSelect;
